import { ReactNode } from "react";
import { ReactComponent as Check } from "src/assets/svg/check2.svg";
import { ReactComponent as X } from "src/assets/svg/x7.svg";

interface ICheckUsageRow {
  children: ReactNode;
  checked: boolean;
}

const CheckUsageRow = ({ children, checked }: ICheckUsageRow) => {
  return (
    <div className="flex gap-[10px] items-center">
      {checked ? <Check className="w-6 h-6 fill-odfblue" /> : <X className="w-6 h-6 fill-red" />}
      <p className=" font-medium text-base ">{children}</p>
    </div>
  );
};

export default CheckUsageRow;
